var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAttachFile48Line = function SvgIconAttachFile48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.52 38.69c-2.69 0-5.39-1.02-7.44-3.07-4.1-4.1-4.1-10.77 0-14.87l9.19-9.19c3.01-3.01 7.92-3.01 10.93 0s3.01 7.92 0 10.93l-9.14 9.14c-.93.93-2.18 1.45-3.5 1.45-1.32 0-2.56-.51-3.5-1.45a4.955 4.955 0 0 1 0-7l7.55-7.55 2.4 2.4-7.55 7.55c-.29.29-.45.68-.45 1.09 0 .41.16.8.45 1.09.58.59 1.6.59 2.19 0l9.14-9.14c1.69-1.69 1.69-4.44 0-6.12-1.69-1.69-4.44-1.69-6.12 0l-9.19 9.19c-2.77 2.77-2.77 7.29 0 10.06 2.77 2.77 7.29 2.77 10.06 0l7.55-7.55 2.4 2.4-7.55 7.55a10.475 10.475 0 0 1-7.44 3.07l.02.02Z",
    fill: "current"
  })));
};
export default SvgIconAttachFile48Line;